export const DEFAULT_ROW_PROCEDIMIENTOS_INGRESO = {
  secuencia: 0,
  key: 0,
  cobertura: "",
  nombreCobertura: "",
  tipoReclamante: "",
  codigoReclamante: "",
  nombreReclamante: "",
  limiteContrato: "",
  frecuencia: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
  coaseguro: "",
  honorarios: "",
  esNuevo: false,
};

export const MAXIMO_DIAS_PERMITIDOS_CIERRE = {
  CON_PRECERTIFICACION_CALENDARIO: 2,
  SIN_PRECERTIFICACION_CALENDARIO: 5,
  CON_EXEPCION_CALENDARIO: 2,
  CONSULTAR_INGRESO_CON_PRECERTIFICACION: 32,
  CONSULTAR_INGRESO_SIN_PRECERTIFICACION: 35,
};

export const CONFIGURACION_COBERTURAS_NO_PERMITIDAS = [1068, 3210, 3211];

export const COBERTURA_VALIDACION = {
  HABITACION_DIARIA: 1064,
};

export const SERVICIO_EXCEPCION = {
  PARTO: 11,
  CESAREA: 12,
  HOSPITALIZACION: 2,
};

export const ESTATUS_COBERTURA = {
  VIGENTE: 61,
};

export const ESTATUS_INGRESO = {
  VIGENTE: "VIGENTE",
  CONVERTIDO: "CONVERTIDO",
};

export const RESPUESTA_PILOTO_CIERRE_CUENTAS = {
  SI_APLICA: "S",
  NO_APLICA: "N",
};

export const USUARIO_WEB = "WEBSALUD";

export const COMENTARIO_POR_DEFECTO = "N/A";

export const CAUSA_POR_DEFECTO = "Consulta";

export const ESTATUS_PERMITIDO = ESTATUS_INGRESO.VIGENTE;

export const MENSAJE_CIERRE_CUENTA = {
  INGRESO_NO_EXISTE:
    "Estimado PSS, el número de ingreso que has digitado no puede ser completado por esta vía. Para completar el proceso de cierre de la cuenta favor de ponerse en contacto con el equipo de contact center al 809-476-3535.",
  INGRESO_REQUIERE_PROCEDIMIENTOS:
    "El ingreso debe tener por lo menos un procedimiento.",
  DIAS_MAXIMOS_PERMITIDOS:
    "Estimado PSS, no es posible completar el cierre de la cuenta clínica debido a que excede el máximo de días permitidos por esta vía. Para poder proceder favor de ponerse en contacto con el equipo de Contact Center al número 809-476-3333 opción 1.",
  DIAS_CALENDARIO_EXCEDIDOS:
    "Estimado PSS, el ingreso ha superado la cantidad de días permitidos por esta vía. Para poder proceder con el cierre de la cuenta, favor de ponerse en contacto con el Contact Center al número 809-476-3333 opción 1",
  DIAS_CALENDARIO_EXCEDIDOS_EXCEPCION:
    "Estimado PSS, no es posible completar el proceso de cierre de cuenta clínica por esta vía. Favor de ponerse en contacto con el Contact Center al 809-476-3333 opción 1",
  FECHA_SERVICIO_EXCEDE_SALIDA:
    "La fecha de salida no puede ser menor a la fecha de servicio.",
  FECHA_SALIDA_EXCEDE_ACTUAL:
    "La fecha de salida no puede ser mayor a la fecha de hoy.",
  COBERTURA_SERVICIO_NO_PERMITIDA:
    "Por esta vía no tiene permiso pasar esta cobertura bajo el servicio seleccionado.",
  EXCEDE_MONTO_MAXIMO:
    "El monto digitado para la cobertura codigoCobertura excede el monto máximo permitido. Para procesar el cierre de la cuenta, por favor póngase en contacto con el equipo de Contact Center al 809-476-3535.",
};

export const RAMO_INGRESO = {
  PRIMERA: 94,
};

export const MAXIMO_DIAS_CONSULTA_CIERRES = 60;

export const TIPO_SERVICIO_PERMITIDO = [
  {
    key: 1,
    label: "Ambulatorio",
    value: "1",
  },
  {
    key: 2,
    label: "Hospitalización",
    value: "2",
  },
  {
    key: 5,
    label: "Maternidad",
    value: "5",
  },
  {
    key: 11,
    label: "Parto",
    value: "11",
  },
  {
    key: 12,
    label: "Cesárea",
    value: "12",
  },
];
